import * as React from "react";
import ButtonLink from "../../Generics/ButtonLink";

export function FlightMarkersGuideButton() {
  return (
    <ButtonLink
      className="placement-guide-button"
      customStyles={{
        pointerEvents: "auto",
        boxShadow: "0 1px 2px 0 rgba(0,0,0,0.3)",
      }}
      type={"control"}
      label="Placement Guide"
      href={"https://flightmarkerguide.traceair.net/"}
      icon={<img src="icon-external-link.svg" width={22} height={22} />}
      otherAttrs={{
        target: "_blank",
        rel: "noreferrer",
      }}
    />
  );
}
